(function () {
  'use strict';
  if (window.mpConversionEventsInstalled) return;
  window.mpConversionEventsInstalled = true;
  var node = document.getElementById('mp-tracking-context');
  if (!node) return;
  var context;
  try { context = JSON.parse(node.textContent); } catch (error) { return; }
  var pendingKey = 'mp:pending-contact:v1';
  var sent = new Set();
  function publish(name, data, key, attempt) {
    if (sent.has(key)) return;
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') {
      if ((attempt || 0) < 20) setTimeout(function () { publish(name, data, key, (attempt || 0) + 1); }, 100);
      return;
    }
    try {
      var result = analytics.publish(name, data);
      sent.add(key);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data));
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
    } catch (error) {}
  }
  function nonce() {
    return window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
  }
  function base() {
    return { page: window.location.pathname, language: context.language, tracking_revision: '2026-10-12', source: context.page_handle || context.page_type };
  }
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : event.target && event.target.parentElement;
    var link = target && target.closest('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (error) { return; }
    if (!['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname) && url.protocol !== 'whatsapp:') return;
    var data = base();
    data.source = link.dataset.waSource || (link.classList.contains('mp-whatsapp-float') ? 'bouton-flottant' : context.product_id ? 'fiche-oeuvre' : context.page_handle === 'ateliers-de-peinture' ? 'ateliers' : data.source);
    data.currency = context.currency;
    if (context.product_id) {
      data.product_id = String(context.product_id);
      data.product_title = context.product_title;
      var selected = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var variantId = selected ? selected.value : new URL(window.location.href).searchParams.get('variant');
      var variant = context.variants.find(function (item) { return String(item.id) === String(variantId); });
      data.price = variant ? variant.price : context.price;
    }
    publish('whatsapp_click', data, nonce());
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var type = form.querySelector('[name="form_type"]');
    if (!type || type.value !== 'contact') return;
    var allowed = ['trouver-une-oeuvre', 'art-pour-votre-projet', 'estimation', 'revente', 'contact', 'ateliers-de-peinture'];
    var name = form.dataset.mpLeadForm || context.page_handle || 'contact';
    if (!allowed.includes(name)) return;
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ form: name, page: window.location.pathname, id: nonce(), at: Date.now() })); } catch (error) {}
  }, true);
  var success = document.querySelector('[data-mp-lead-success]');
  if (success) {
    var pending;
    try { pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch (error) {}
    if (pending && Date.now() - pending.at >= 0 && Date.now() - pending.at < 30 * 60 * 1000) {
      var expected = success.dataset.mpLeadSuccess;
      if (expected === pending.form || expected === 'contact') {
        try { sessionStorage.removeItem(pendingKey); } catch (error) {}
        var data = base();
        data.form = pending.form;
        data.page = pending.page;
        data.submission_id = pending.id;
        publish('form_lead', data, pending.id);
      }
    }
  }
})();
